// src/constants/display-scale.ts
export type ScaleUnit = 'hour' | 'day'
export type ScaleSize = 'large' | 'medium' | 'small'

export type DisplayScale = {
  unit: ScaleUnit
  size: ScaleSize
}

export const DEFAULT_DISPLAY_SCALE: DisplayScale = {
  unit: 'hour',
  size: 'large'
}

export const ROW_HEIGHT_BY_SIZE: Record<ScaleSize, number> = {
  large: 120,
  medium: 120,
  small: 66
}

/** スケール種別（時/日） */
export type DispatchScheduleViewKind = 'hour' | 'day'

/** 表示モード（Dropdown の5種に対応） */
export type DispatchScheduleViewMode =
  | 'hour-large'
  | 'hour-medium'
  | 'hour-small'
  | 'day-medium'
  | 'day-small'

/** 日モードの安定ソートキー（仕様：startAt → endAt → id） */
export type DayModeSortKey = 'startAt' | 'endAt' | 'id'

/** start/end を持つ最小限の要素（ユーティリティ関数の引数用） */
export type WithStartEndId = {
  id: number
  startAt: string | Date
  endAt: string | Date
}
